import { render, staticRenderFns } from "./Attention.vue?vue&type=template&id=4271b228&scoped=true"
import script from "./Attention.vue?vue&type=script&lang=js"
export * from "./Attention.vue?vue&type=script&lang=js"
import style0 from "./Attention.vue?vue&type=style&index=0&id=4271b228&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4271b228",
  null
  
)

export default component.exports